import CorretajeTradicional from '../assets/img/Inicio/Principal/corretaje-tradicional.jpg';
import AdministraciónInteligente from '../assets/img/Inicio/Principal/administracion-inteligente.webp';
import AdministraciónConGarantia from '../assets/img/Inicio/Principal/administracion-con-garantia.webp';

export const leaseData = [
  {
    id: 1,
    title: 'Corretaje tradicional',
    src: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692217818/Projects/aulen/inicio/INICIO__CORRETAJE_TRADICIONAL_wgmruq.webp',
    href: '/administracion-de-arriendo',
    itemsList: [
      'Nuestros ejecutivos se encargarán desde el Estudio y Evaluación de mercado hasta el acta de entrega de la propiedad, demostrando habilidades como la capacidad de negociación, comunicación efectiva, conocimientos de mercado y de las leyes que ayudarán a arrendar tu propiedad en tiempo récord.',
    ],
  },
  {
    id: 2,
    title: 'Administración inteligente',
    src: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692217818/Projects/aulen/inicio/INICIO__ADMINISTRACION_INTELIGENTE_yhit2w.webp',
    href: '/administracion-de-arriendo',
    itemsList: [
      'Cuenta con la gestión y el respaldo de nuestro equipo de Administración de arriendo. ',
      'Aseguramos el pago del arriendo los 5 de cada mes. ',
      'Verificamos que los servicios y gastos comunes estén al día. Gestionamos las reparaciones y manutenciones necesarias. ',
      'Respaldo de Servicios Legales.',
    ],
  },
  {
    id: 3,
    title: 'Administración con garantía',
    src: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692217821/Projects/aulen/inicio/INICIO__ADMINISTRACION_CON_GARANTIA_lqhd9m.webp',
    href: '/administracion-de-arriendo',
    itemsList: [
      'Disfruta de la tranquilidad de contar con nuestro servicio de administración que te ofrece hasta 6 meses de arriendo en caso de no pago de tu arrendatario. ',
      'Además, contarás con servicios legales en caso de que sea necesario el desalojo o daños a terceros. ',
    ],
  },
];
